// /src/pages/private/members/dashboard/dashboardHistoryApi.js

import axios from 'axios';

/** @param {number} handleId @param {{ scope?: string, filter?: string, year?: number }} [opts] */
export async function fetchDashboardHistoryEvents(handleId, opts = {}) {
  const { scope = 'cluster', filter = 'total', year } = opts;
  const { data } = await axios.post(
    '/api/user/private-dashboard/history-events',
    { handleId, scope, filter, year },
    { withCredentials: true },
  );
  return data;
}

/** @param {number} handleId @param {{ filter?: string, year?: number }} [opts] */
export async function fetchDashboardHistoryCredits(handleId, opts = {}) {
  const { filter = 'total', year } = opts;
  const { data } = await axios.post(
    '/api/user/private-dashboard/history-credits',
    { handleId, scope: 'cluster', filter, year },
    { withCredentials: true },
  );
  return data;
}

/** @param {number} handleId @param {{ filter?: string, year?: number }} [opts] */
export async function fetchDashboardHistoryLoot(handleId, opts = {}) {
  const { filter = 'total', year } = opts;
  const { data } = await axios.post(
    '/api/user/private-dashboard/history-loot',
    { handleId, scope: 'cluster', filter, year },
    { withCredentials: true },
  );
  return data;
}
